"use client";
import Link from 'next/link';
import { useState, useEffect, useRef } from 'react';
import { usePathname } from 'next/navigation';

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  const pathname = usePathname();
  const showNavbar = pathname === '/' || (typeof pathname === 'string' && pathname.endsWith('/login'));
  const primaryColor = process.env.NEXT_PUBLIC_THEME_PRIMARY || '#3B82F6';

  // close dropdown on outside click
  useEffect(() => {
    function handleClick(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);

  if (!isClient) {
    return null;
  }

  if (!showNavbar) {
    return null;
  }

  return (
    <nav className="w-full bg-white border-b border-gray-100">
      <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between">
        <div className="flex items-center space-x-6">
          <Link href="/" className="text-xl font-bold text-gray-800">StartupWorld</Link>
          <div className="flex items-center space-x-4 text-gray-600">
            <Link href="#" style={{ color: primaryColor }} className="hover:underline">Features</Link>
            <Link href="#" style={{ color: primaryColor }} className="hover:underline">Programs</Link>
            <Link href="#" style={{ color: primaryColor }} className="hover:underline">Reviews</Link>

            {/* Register dropdown */}
            <div
              className="relative"
              ref={ref}
              onMouseEnter={() => setOpen(true)}
              onMouseLeave={() => setOpen(false)}
            >
              <button
                onClick={() => setOpen(!open)}
                className="flex items-center gap-2 px-3 py-1 rounded-md hover:bg-gray-50"
                aria-expanded={open}
                aria-haspopup="menu"
                style={{ color: primaryColor }}
              >
                Register
                <svg className="w-4 h-4" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" style={{ color: primaryColor }}>
                  <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z" clipRule="evenodd" />
                </svg>
              </button>

              {open && (
                <div className="absolute left-0 mt-2 w-64 bg-white border border-gray-100 rounded-lg shadow-lg z-20">
                  <div className="py-2">
                    <div className="px-4 py-2 text-sm text-gray-800 font-semibold">Create Your Profile</div>
                    <div className="border-t border-gray-100 my-1" />
                    <Link href="/student/register" onClick={() => setOpen(false)} className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50">Register Student</Link>
                    <Link href="/college/register" onClick={() => setOpen(false)} className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50">Register College</Link>
                    <Link href="/teacher/register" onClick={() => setOpen(false)} className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50">Register Teacher</Link>
                    <Link href="/employer/register" onClick={() => setOpen(false)} className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50">Register Employer</Link>
                    <Link href="/sponsorer/register" onClick={() => setOpen(false)} className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50">Register Sponsorer</Link>
                    <Link href="/mentor/register" onClick={() => setOpen(false)} className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50">Register Mentor</Link>
                    <Link href="/winners/today" onClick={() => setOpen(false)} className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50">Today Winners</Link>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="flex items-center space-x-4">
          <Link href="/student/login" className="text-sm text-gray-700 hover:text-gray-900">Student Login</Link>
          <Link href="/employer/login" className="text-sm text-gray-700 hover:text-gray-900">Employer Login</Link>
          <Link href="/staff/login" className="text-sm text-gray-700 hover:text-gray-900">Staff Login</Link>
          <Link href="/teamleader/login" className="text-sm px-3 py-1.5 bg-purple-600 text-white rounded-md hover:bg-purple-700 transition-colors">Team Leader Login</Link>
        </div>
      </div>
    </nav>
  );
}